import styled, { css } from 'styled-components';

import {
  ThemeProps as Prop, Breakpoints, FontSize, FontFamily,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

export const StyledDorSectorReport = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
`;

export const SectorGraph = styled.div`
  display: flex;
  flex-direction: column;

  ${({ isParentNavFeed }) => ((isParentNavFeed) ? 'padding: 0 5px; flex: 33.3% 0;' : 'padding: 0 5px; flex: 25% 0;')}

  hr {
    width: 100%;
  }

  h3 {
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.MED10, undefined, undefined)};
    text-align: center;
    text-transform: capitalize;
    line-height: 1.2;
  }
`;
